import { render, staticRenderFns } from "./uf_is_ndt.vue?vue&type=template&id=5d5a07d1&scoped=true"
import script from "./uf_is_ndt.vue?vue&type=script&lang=js"
export * from "./uf_is_ndt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a07d1",
  null
  
)

export default component.exports